<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    @if (this.actionStack!.getValue('coIPresenceVanneRemplissage') === 1) {
      <app-switch-configuration
        [title]="'P00076.parameters.remplissage.activer' | translate"
        [nameCustom]="'P00076.parameters.remplissage.activer.title' | translate"
        [description]="
          'P00076.parameters.remplissage.activer.description' | translate
        "
        [value]="actionStack!.getValue('coPActivaterRemplissage') !== 0"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPActivaterRemplissage',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-switch-configuration
        [nameCustom]="
          'P00076.parameters.remplissage.activerprotection.title' | translate
        "
        [description]="
          'P00076.parameters.remplissage.activerprotection.description'
            | translate
        "
        [value]="
          actionStack!.getValue(
            'coPActivationFonctionProtectionDebitRemplissage'
          ) !== 0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPActivationFonctionProtectionDebitRemplissage',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-switch-configuration
        [nameCustom]="
          'P00076.parameters.remplissage.activersecurite.title' | translate
        "
        [description]="
          'P00076.parameters.remplissage.activersecurite.description'
            | translate
        "
        [value]="
          actionStack!.getValue('coPActivationFonctionSecuriteRemplissage') !==
          0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPActivationFonctionSecuriteRemplissage',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-label-configuration
        [titleListe]="
          'P00076.parameters.remplissage.dureemaximum.title' | translate
        "
        [value]="
          actionStack!.getValue('coPDureeMaximumOuvertureVanneRemplissage')
        "
        [liste]="P00076DureeTypeEnum"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPDureeMaximumOuvertureVanneRemplissage',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }

    @if (this.actionStack!.getValue('coIPresenceVanneVidange') === 1) {
      <app-switch-configuration
        [title]="'P00076.parameters.vidange.activer' | translate"
        [nameCustom]="'P00076.parameters.vidange.activer.title' | translate"
        [description]="
          'P00076.parameters.vidange.activer.description' | translate
        "
        [value]="actionStack!.getValue('coPActivaterVidange') !== 0"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPActivaterVidange',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-switch-configuration
        [nameCustom]="
          'P00076.parameters.vidange.activerprotection.title' | translate
        "
        [description]="
          'P00076.parameters.vidange.activerprotection.description' | translate
        "
        [value]="
          actionStack!.getValue(
            'coPActivationFonctionProtectionDebitVidange'
          ) !== 0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPActivationFonctionProtectionDebitVidange',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-switch-configuration
        [nameCustom]="
          'P00076.parameters.vidange.activersecurite.title' | translate
        "
        [description]="
          'P00076.parameters.vidange.activersecurite.description' | translate
        "
        [value]="
          actionStack!.getValue('coPActivationFonctionSecuriteVidange') !== 0
        "
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPActivationFonctionSecuriteVidange',
            $event ? 1 : 0,
            null
          )
        "
      >
      </app-switch-configuration>

      <app-label-configuration
        [titleListe]="
          'P00076.parameters.vidange.dureemaximum.title' | translate
        "
        [value]="actionStack!.getValue('coPDureeMaximumOuvertureVanneVidange')"
        [liste]="P00076DureeTypeEnum"
        (onPress)="
          this.actionStack!.editValue(
            P00039DataRxTxIndex.Constance_Parametrage,
            'coPDureeMaximumOuvertureVanneVidange',
            $event,
            null
          )
        "
      >
      </app-label-configuration>
    }
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
